// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"130":"db37ad1f","441":"ee3bf835"}[chunkId] + ".css";
};